export var defaultState = {
    updating: {
        status: 'none',
    },
    deleting: {
        status: 'none',
    },
};
